import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun, toJS } from 'mobx';
import DataTable from '../DataTable';
import Spinner from '../Spinner';

@inject('qcRuleStore', 'qcTypeStore', 'qcFlagStore')
@observer
class QCRuleList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
    qcRuleStore: PropTypes.object.isRequired,
    qcTypeStore: PropTypes.object.isRequired,
  }

  dispose = null;
  @observable itemsWithDetails = [];

  componentWillMount() {
    const { qcRuleStore, qcTypeStore, qcFlagStore } = this.props;

    qcTypeStore.fetchItems();
    qcRuleStore.fetchItems();
    if(!qcFlagStore.items.length && !qcFlagStore.isLoading) qcFlagStore.fetchItems();
    this.handleDelete = this.handleDelete.bind(this);

    // this.dispose = autorun(() => {
    //   this.reset(qcRuleStore.itemsWithDetails);
    // });
  }

  // componentWillUnmount() { this.dispose(); }

  // @action reset(itemsWithDetails) {
  //   if (itemsWithDetails) {
  //     this.itemsWithDetails = itemsWithDetails;
  //   }
  // }

  slug = 'qc/rule';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'type_name', label: 'Type' },
    { key: 'description', label: 'Description' },
    { key: 'flag.description', label: 'Error Flag' },
    { key: 'typeDetails', label: 'Details' },
  ];

  handleDelete(idOrIds) {
    this.props.qcRuleStore.removeItems(idOrIds);
  }

  render() {
    const { qcRuleStore, qcTypeStore, qcFlagStore, children } = this.props;

    if(qcRuleStore.isLoading || qcTypeStore.isLoading || qcFlagStore.isLoading) { return <Spinner />; }

    const itemsWithDetails = qcRuleStore.items.map(item => {
      let typeDetails = '';
      if (item.type === 1) {
        typeDetails = `Lower Threshold: ${item.threshold && item.threshold.lower_threshold}, ` +
          `Upper Threshold: ${item.threshold && item.threshold.upper_threshold}`;
      }
      if (item.type === 2) {
        typeDetails = `Max Change: ${item.step && item.step.max_change}, ` +
          `Interval: ${item.step && item.step.interval}`;
      }
      if (item.type === 3) {
        typeDetails = `Threshold: ${item.constant && item.constant.threshold}, ` +
          `Interval: ${item.constant && item.constant.interval}`;
      }
      if (item.type === 4) {
        typeDetails = `Reference: ${item.value_check && item.value_check.reference}`;
      }
      return {
        ...item,
        typeDetails,
        flag: qcFlagStore.items.find(flag => +flag.caption === +item.qc_flag)
      };
    });

    return (
      <div>
        <DataTable
          data={itemsWithDetails}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='qc-rule'
        />
        <div>
          {children}
        </div>
      </div>
    );
  }
}

export default QCRuleList;



// WEBPACK FOOTER //
// ./src/components/QCRule/QCRuleList.js